<template>
    <div>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form 
                @submit.stop.prevent="handleSubmit(onSubmit)" 
                autocomplete="off"
                v-show="!refill_widget_is_visible"
            >
                <validation-provider
                    name="Сума поповнення"
                    :rules="{ required: true, regex: /^\d+([.,]\d{1,2})?$/ }"
                    v-slot="validationContext"
                ><!--:rules="{ required: true , numeric: true }"-->

                    <b-form-group id="refill-input-group" label="" label-for="refillsum">
                        <b-input-group prepend="₴" class="mt-3">
                            <b-form-input 
                                id="refillsum"
                                name="refillsum"
                                ref="refillsum"
                                v-model="refillsum"
                                shadow-none
                                placeholder="Введіть сумму поповнення"
                                autocomplete="off"
                                type="text"
                                inputmode="decimal" 
                                :state="getValidationState(validationContext)"
                                aria-describedby="refillsum-live-feedback"
                                spellcheck="false" 
                                autocorrect="off" 
                                autocapitalize="off" 
                            ></b-form-input>
                            <!--b-input-group-append>

                                <b-overlay
                                    :show="busy"
                                    rounded
                                    opacity="0.6"
                                    spinner-small
                                    spinner-variant="bruvis"
                                    class="d-inline-block"
                                    @hidden="onHidden"
                                >
                                    <b-button
                                        ref="button"
                                        type="submit"
                                        :disabled="busy"
                                        variant="bruvis"
                                    >
                                        Поповнити
                                    </b-button>
                                </b-overlay>
                            </b-input-group-append-->
                        </b-input-group>
                        <b-form-invalid-feedback id="refillsum-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                <b-overlay
                  :show="globalbusy"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="bruvis"
                  class="d-inline-block w-100"
                >
                  <b-button 
                      v-if="settings && settings.use_liqpay"
                      type="submit"
                      :disabled="globalbusy"
                      @click="metod='liqpay'"
                      block size="lg" variant="light border-secondary"
                      class="p-4 mb-2"
                      style="height: 80px;"
                      title="Поповнити карткою онлайн з LiqPay"
                    >
                      <b-img 
                        src="img/logo_liqpay_white_bg.svg" 
                        class="h-100" 
                        style="object-fit: contain; max-height: 100%;" 
                      />
                  </b-button>
                  <b-button 
                    v-if="settings && settings.use_monopay"
                    type="submit"
                    :disabled="globalbusy"
                    @click="metod='monopay'"
                    block size="lg" variant="light border-secondary"
                    class="p-4 py-3 mb-2"
                    style="height: 80px;"
                    title="Поповнити карткою онлайн з monopay"
                  >
                    <b-img 
                      src="img/plata_light_bg.svg" 
                      class="h-100" 
                      style="object-fit: contain; max-height: 100%;" 
                    />
                  </b-button>
                  <div v-else class="alert alert-warning">
                    Помилка конфігурації: не встановлено платіжну систем!у
                  </div>                                    
                </b-overlay>  




            </b-form>
        </validation-observer>
        
        <div id="refill_liqpay_checkout"></div>
    </div>    

</template>

<script>
export default {
  name: 'RefillCard',
  props: {
     settings:{
      type: Object,
      required: true
    }

  },
  data: () => ({
      refillsum: null,
      refill_widget_is_visible: false,
      getStatusInt: null,
      metod: null,
      lpay: null,
      globalrns: null
  }),

  methods:{
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      const cleanSum = parseFloat(this.refillsum.replace(',', '.'));
      if (isNaN(cleanSum) || cleanSum <= 0) return;
      this.refillBallance(cleanSum,this.metod)
    },
    /*
    onHidden() {
        this.$refs.button.focus()
    },*/
    refillBallance(sum,metod){
        this.globalbusy = true
        document.getElementById('refill_liqpay_checkout').innerHTML=''
        this.$axios.post('', {"action":"refillballance","sum":sum,"metod":metod} )
                  .then((response) => {

                    this.globalrns = response.data.order_id
                    this.$root.$emit("set-globalrns", response.data.order_id)

                    if(response.data.success != 'false' && metod=='liqpay'){   
                      // LIQPAY -------------------------------------------------                        

                        if(this.lpay){
                                //eslint-disable-next-line
                                this.lpay = LiqPayCheckout.init({
                                  "data": response.data.liqpay.data,
                                  "signature": response.data.liqpay.signature,
                                  "embedTo": "#refill_liqpay_checkout",
                                  "language": "uk",
                                  "mode": "embed", // embed || popup
                                  "paytypes" : "card gpay qr"
                                })
                        }else{
                                  //eslint-disable-next-line
                                  this.lpay = LiqPayCheckout.init({
                                    "data": response.data.liqpay.data,
                                    "signature": response.data.liqpay.signature,
                                    "embedTo": "#refill_liqpay_checkout",
                                    "language": "uk",
                                    "mode": "embed", // embed || popup
                                    "paytypes" : "card gpay qr"
                                  }).on("liqpay.callback", function(data){  
                                      console.log('Callback '+this.globalrns)
                                      if (!data || Object.keys(data).length === 0 || !data.status) {
                                        console.warn('Відміна платежу користувачем');
                                        this.refill_widget_is_visible = false;
                                        return; 
                                      }
                                      if(data.status === 'success'){
                                        console.log('Status is "Success"')
                                        setTimeout(() => this.requestToPayStatus(this.globalrns), 2000)
                                      }else if(data.status === 'wait_secure'){
                                        console.log('Status is "wait_secure"')
                                        this.$toasted.info('Увага! Банк призупинив платіж для додаткової перевірки').goAway(5000)
                                        this.$toasted.info('Це може тривати від 30 хвилин до 2 годин').goAway(5000)
                                      }else{
                                        console.log('Data status is not "success"!',data)
                                      }  
                                    }.bind(this)
                                  ).on("liqpay.ready", function(){
                                      this.globalbusy = false
                                      const iframe = document.querySelector('#refill_liqpay_checkout iframe');
                                      if (iframe) {
                                        iframe.style.setProperty('height', '100%', 'important');
                                      }
                                      this.refill_widget_is_visible = true
                                    }.bind(this)
                                  );
                        }
                        //------------------- LIQPAY END 

                      // old LiqPay begin---------------------------                
                      /*
                      //this.globalbusy = false
                      //eslint-disable-next-line
                      LiqPayCheckout.init({
                        "data": response.data.data,
                        "signature": response.data.signature,
                        "embedTo": "#refill_liqpay_checkout",
                        "language": "uk",
                        "mode": "embed" // embed || popup
                      }).on("liqpay.callback", function(data){
                          console.log('Callback')
                          console.log(data.status)
                          console.log(data)
                          if( this.getStatusInt === null)
                            this.getStatusInt = setInterval(function(){
                              this.$axios.post('', {"action":"getrefillstatus","rn": response.data.order_id} )
                                  .then((response) => {
                                      let result = response.data
                                      switch(result.status){
                                          case 'wait':
                                            console.log('wait')
                                            break
                                          case 'success':
                                            console.log('success')
                                            clearInterval(this.getStatusInt)
                                            this.$toasted.success(result.message).goAway(3000)
                                            //this.$parent.$emit('onRefill')              
                                            this.$emit('onRefill') 
                                            break
                                          case 'ready':
                                            console.log(result.data)
                                            clearInterval(this.getStatusInt)
                                            this.$toasted.warning(result.message).goAway(3000)
                                            break
                                          default:
                                            console.log(result)  
                                        } 

                                  })
                                  .catch(error => {
                                    console.error('There was an error!', error)
                                  });
                            }.bind(this), 2000);
                        }.bind(this)
                      ).on("liqpay.ready", function(data){

                        console.log(data.status)
                        this.refill_widget_is_visible = true
                        }.bind(this)
                      ).on("liqpay.close", function(data){
                          // close
                          console.log('Close')
                          console.log(data)
                      });
                      */
                      // old LiqPay end---------------------------                
                    }else if(response.data.success != 'false' && metod=='monopay'){  
                      //
                        //this.globalbusy = true
                        this.hide_close_button = true
                        const url = response.data.monopay.pageUrl
                        const container = document.getElementById('refill_liqpay_checkout')
                        
                        if (container) {
                          container.innerHTML = ''
                          const iframe = document.createElement('iframe')
                          iframe.className = 'embed-responsive-item'
                          iframe.src = url
                          iframe.setAttribute('allow', 'payment *')
                          iframe.setAttribute('ref', 'monoIframe')
                          iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-storage-access-by-user-activation')
                          iframe.setAttribute('frameborder', '0')
                          iframe.style.width = '100%'
                          iframe.style.height = '100%'
                          iframe.style.minHeight = '500px'
                          iframe.style.border = 'none'
                          container.appendChild(iframe)
                        }
                        this.refill_widget_is_visible = true
                        this.globalbusy = false
                        this.orderbusy = false

                    }else{
                      if(response.data.error=="auth" || response.data.error=="tokenout"){
                        this.$emit('needlogin')
                        console.log('auth')
                      }else{
                        this.$toasted.error(response.data.message).goAway(3000) 

                      }
                    }  
                  })
                  .catch(error => {
                    this.globalbusy = false
                    console.error('There was an error!', error)
                  });
    },
    requestToPayStatus(rns){
      console.log('Request 4 paystatus')
      this.$axios.post('', {"action":"getrefillstatus","rn": rns} )
        .then((response) => {
          let result = response.data
          switch(result.status){
            case 'wait':
              console.log('wait')
              this.$toasted.info('Очікуємо на підтвердження платежу').goAway(2000)
              setTimeout(() => this.requestToPayStatus(rns), 2000)
              break
            case 'success':
              console.log('success')
              this.$toasted.success(result.message).goAway(3000)              
              this.$emit('onRefill') 
              break
            case 'ready':
              console.log(result.data)
              this.$toasted.error(result.message).goAway(3000)
              //this.onSuccessPay()
              break
            default:
              console.log(result)  
          } 
        })
        .catch(error => {
          this.globalbusy = false
          console.error('There was an error!', error)
        });
    },

    

  }
}
</script>

<style scoped>

    @media (max-width: 575px) {

    }

    @media (hover: none) {
    
    }    

</style>

